import { render, staticRenderFns } from "./situation.vue?vue&type=template&id=354366f2&scoped=true"
import script from "./situation.vue?vue&type=script&lang=js"
export * from "./situation.vue?vue&type=script&lang=js"
import style0 from "./situation.vue?vue&type=style&index=0&id=354366f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354366f2",
  null
  
)

export default component.exports